/******************************************************************/
/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
/******************************************************************/

angular.module('app.directives').directive('selectPracticeAreasSimple', function() {
return {
  restrict: 'AE',
  scope: {
    practicesModel: "=",
    practiceAreas: "=",
    onPracChange: '&'
  },
  replace: true,
  template: `
    <span class="ui-select margin-0">
      <select class="admin-filter practice-filter width-inherit" ng-change="onPracChange('practice');" ng-model="practicesModel">
        <option value='' disabled selected style='display:none;'>Practice Area</option>
        <option value="All">All</option>
        <option ng-repeat="area in practiceAreas" value="{{area.practice_ID}}">{{area.practice_name}}</option>
      </select>
    </span>
  `,
    controller: function($scope, $log, practicesService) { }
  };
})



// WEBPACK FOOTER //
// ./scripts/shared/directives/select-practice-areas-simple.js